import QueueAPI from '@/api/queue'
// initial state
const state = {
  errors: 0,
  entries: []
}

// getters
const getters = {
  getErrors (state) {
    return state.errors
  },
  getEntries (state) {
    return state.entries
  }
}

// actions
const actions = {
  setEntries (store, data) {
    store.commit('setEntries', data)
  },
  async fetchEntries (store, data) {
    let entries = await QueueAPI.getList()
    store.commit('setEntries', entries)
    store.commit('setErrors', entries.filter((entry) => entry.error))

    return entries
  },
  clear (store) {
    return QueueAPI.clearErrors()
  }
}

// mutations
const mutations = {
  setEntries (state, data) {
    state.entries = data
  },
  setErrors (state, data) {
    state.errors = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
